<ng-container *transloco="let t">
  <!-- Slotted content above header (for e.g. licence header) -->
  <ng-content></ng-content>

  <div class="header">
    <!-- Top header section -->
    <div class="top-wrapper">
      <!-- Burger -->
      <div class="burger" (click)="sidebarService.openMenu$.next()">
        <span class="line"></span>
        <span class="line"></span>
        <span class="line"></span>
      </div>
      <!-- Back button -->
      <i *ngIf="showBackButton" class="material-symbols-rounded app-back" (click)="back()">arrow_back_ios_new</i>
      <!-- Title -->
      <div class="header-title">
        <h1>{{ title$ | async }}</h1>
        <span *ngIf="smallTextTitle$ | async as smallTextTitle">({{ smallTextTitle }})</span>
      </div>

      <!-- Submenu ???? -->
      <ng-container *ngIf="showSubMenu$ | async as showSubMenu">
        <app-context-menu *ngIf="showSubMenu.show" [menuType]="showSubMenu.menuType" [data]="data"></app-context-menu>
      </ng-container>

      <!-- Expand bottom section button -->
      <button
        type="button"
        class="btn btn-outline-primary btn-icon btn-expand"
        [ngClass]="{
          active: (bottomContentExpanded$ | async)
        }"
        (click)="bottomContentExpanded$.next(!bottomContentExpanded$.value)"
      >
        <i class="material-symbols-rounded filled">
          <ng-container *ngIf="bottomContentExpanded$ | async">close</ng-container>
          <ng-container *ngIf="(bottomContentExpanded$ | async) === false">more_horiz</ng-container>
        </i>
      </button>

      <!-- Group and children filters -->
      <ng-container *ngTemplateOutlet="groupAndChildrenFilter; context: { class: 'desktop' }"></ng-container>

      <!-- Right section -->
      <div class="right-section">
        <!-- Inputs -->
        <ng-container *ngTemplateOutlet="inputs; context: { isDesktop: true }"></ng-container>

        <!-- Buttons -->
        <ng-container *ngTemplateOutlet="buttons; context: { isDesktop: true }"></ng-container>

        <!-- Workplace selector -->
        <app-workplace-selector class="desktop" *ngIf="isDirector"></app-workplace-selector>
        <!-- Logged user -->
        <app-logged-user class="desktop"></app-logged-user>
      </div>
    </div>

    <!-- Inputs (mobile under header) -->
    <ng-container *ngTemplateOutlet="inputs"></ng-container>

    <!-- Bottom header section -->
    <div
      class="bottom-wrapper"
      [ngClass]="{
        expanded: (bottomContentExpanded$ | async)
      }"
    >
      <!-- Tablet and (less) mobile items  -->
      <div class="bottom-wrapper-section">
        <span class="bottom-wrapper-section-title">{{ t('shared/show') }}</span>
        <!-- Group and children filters -->
        <ng-container *ngTemplateOutlet="groupAndChildrenFilter; context: { class: 'mobile' }"></ng-container>
        <!-- Buttons -->
        <ng-container *ngIf="(breakpoint$ | async) === 'tablet'">
          <ng-container *ngTemplateOutlet="buttons; context: { isTablet: true }"></ng-container>
        </ng-container>
      </div>

      <!-- Mobile items -->
      <div class="bottom-wrapper-section mobile">
        <span class="bottom-wrapper-section-title">{{ t('shared/moreActions') }}</span>
        <!-- Demo school -->
        <button *ngIf="showDemoSwitch" type="button" class="btn btn-primary demo" (click)="switchDemoKindergartenService.switch()">
          <span>{{ t('demo/title') }}</span>
        </button>
        <!-- Buttons -->
        <ng-container *ngTemplateOutlet="buttons"></ng-container>

        <!-- Workplace selector -->
        <app-workplace-selector *ngIf="isDirector"></app-workplace-selector>

        <!-- Logged user -->
        <app-logged-user class="desktop"></app-logged-user>
      </div>
    </div>
  </div>
</ng-container>

<!-- Sub-header slot (page-specific sticky content) -->
<ng-container *ngIf="(helperService.subHeaderTemplate$ | async) && (bottomContentExpanded$ | async) === false">
  <ng-container [ngTemplateOutlet]="helperService.subHeaderTemplate$ | async"></ng-container>
</ng-container>

<!-- Group and children filters -->
<ng-template #groupAndChildrenFilter let-class="class">
  <ng-container *ngIf="showGroupAndChildrenFilter$ | async as showGroupAndChildrenFilter">
    <app-group-and-children-filter
      *ngIf="showGroupAndChildrenFilter.showChildren || showGroupAndChildrenFilter.showGroup"
      class="group-filter"
      [ngClass]="class"
      [showGroup]="showGroupAndChildrenFilter.showGroup"
      [showChildren]="showGroupAndChildrenFilter.showChildren"
    ></app-group-and-children-filter>
  </ng-container>
</ng-template>

<!-- Inputs -->
<ng-template #inputs let-isDesktop="isDesktop">
  <ng-container *ngIf="helperService.inputs$ | async as inputs">
    <div
      *ngFor="let input of inputs"
      [formGroup]="input.formGroup"
      class="form-group header-search"
      [ngClass]="{
        active: input.formGroup.controls[input.formControlName]?.value,
        desktop: isDesktop,
        mobile: !isDesktop
      }"
    >
      <i *ngIf="input.icon" class="material-symbols-rounded prepend-icon">{{ input.icon }}</i>
      <input
        type="text"
        class="form-control form-control-rounded form-control-prepend"
        [placeholder]="input.placeholder"
        [formControlName]="input.formControlName"
      />
    </div>
  </ng-container>
</ng-template>

<!-- Buttons -->
<ng-template #buttons let-isDesktop="isDesktop" let-isTablet="isTablet">
  <ng-container *ngIf="helperService.buttons$ | async as buttons">
    <button
      *ngFor="let button of buttons"
      type="button"
      class="btn"
      [ngClass]="{
        'btn-outline-primary': button.style === 'outline',
        'btn-primary': button.style === 'primary',
        'btn-icon': button.icon,
        desktop: isDesktop,
        tablet: isTablet,
        keep: button.keepOnTop
      }"
      [ngbTooltip]="button.tooltip"
      (click)="button.onClick()"
    >
      <i *ngIf="button.icon" class="material-symbols-rounded filled">{{ button.icon }}</i>
      <span *ngIf="button.text">{{ button.text }}</span>
    </button>
  </ng-container>
</ng-template>
